import React, { ReactNode } from 'react';
import classNames from 'classnames';

const Masonry = ({ children, ...props }: { children: ReactNode[] }) => {
  const firstChild = children[0];
  const secondChild = children[1];
  const thirdChild = children[2];

  const firstOrSecondChildPresent = children[1] || children[0];

  return (
    <div className="flex md:flex-shrink-0 space-x-3 md:max-w-[680px]" {...props}>
      {firstOrSecondChildPresent && (
        <div
          className={classNames(
            'flex flex-col justify-between h-full max-h-[380px] md:max-h-[630px] md:max-w-[220px] space-y-3',
            'w-auto min-w-[130px] md:w-full',
          )}
        >
          {firstChild && <div className="h-[48%] md:h-[50%]">{firstChild}</div>}
          {secondChild && <div className="h-[48%] md:h-[50%]">{secondChild}</div>}
        </div>
      )}
      {thirdChild && (
        <div className="w-full min-w-[220px] max-h-[380px] md:max-h-[630px]">{thirdChild}</div>
      )}
    </div>
  );
};

export default Masonry;
